
export default {
  'oms.common.sku': 'SKU',
  'oms.common.warehouse': 'Warehouse',
  'oms.common.store_name': 'Store Name',
  'oms.common.declared_value': 'Declared Value',
  'oms.common.declared_currency': 'Declared Currency' ,
  'oms.common.message.destination_country': '請選擇到達國家',
  'oms.common.loading': 'Loading',
  'oms.common.customer_store_key': 'Customer Store Key',
  'oms.common.customer_sap_code': 'Customer SAP Code',
  'oms.common.batch_request_code': 'Batch Request Code',
  'oms.common.export_to_excel': '匯出Excel',
  'oms.common.downloading': '下載中',
  'oms.common.download-fail': ' 下載失敗，請重試',
  'oms.common.processing': '處理中',
  'oms.common.cancelling': '取消中',
  'oms.common.generating': '生成中',
  'oms.common.delete_this_line': '確定要刪除這行數據嗎?',
  'oms.common.go_back': '返回',
  'oms.common.status': '狀態',
  'oms.common.amr_pick_status': '揀貨單狀態',
  'oms.common.merchant': '貨主',
  'oms.common.platform_code': '電商平台',
  'oms.common.external_oms_status': '外部 oms 狀態',
  'oms.common.external_client_status': '外部客戶狀態',
  'oms.common.container_box': '箱號',
  'oms.common.oms_product_sku': 'oms 產品號碼 SKU',
  'oms.common.oms_product_bar_code': 'oms 產品代碼',
  'oms.common.bin': '架位',
  'oms.common.bar_code': '產品條碼',
  'oms.common.product_name': '產品名稱',
  'oms.common.ean': 'EAN / UPC 條碼',
  'oms.common.good-stock': '好貨',
  'oms.common.like-new-stock': '像新的',
  'oms.common.bad-stock': '壞貨',
  'oms.common.normal_qty': '好貨數量',
  'oms.common.damage_qty': '壞貨數量',
  'oms.common.quantity': '數量',
  'oms.common.put_away.quantity': '上架數',
  'oms.common.production_batch_code': '產品批次號',
  'oms.common.production_batch_code_qty': '產品批次號數量',
  'oms.common.origin_production_batch_code': '原產品批次號',
  'oms.common.expected_qty': '預期數量',
  'oms.common.virtual_warehouse': '虛擬倉庫',
  'oms.common.carrier': '快遞商',
  'oms.common.zone': '區域',
  'oms.common.warehouse.bin': '架位',
  'oms.common.warehouse.bin_zone': '架區',
  'oms.common.warehouse.aisle': '通道',
  'oms.common.warehouse.bay': '間隔',
  'oms.common.warehouse.level': '層',
  'oms.common.warehouse.position': '位',
  'oms.common.inventory_status': '庫存狀態',
  'oms.common.waybill': '貨運單',
  'oms.common.invoice': '發票',
  'oms.common.processing.message': '處理中 ...',
  'oms.common.updating.message': '更新中 ...',
  'oms.common.removing.message': '移除中 ...',
  'oms.common.removing.fail.message': '移除失敗',
  'oms.common.message.download.successfully': '已成功下載',
  'oms.common.operate_warehouse': '當前操作倉庫',
  'oms.common.select_operate_warehouse': '請選擇操作倉庫',
  'oms.common.select_company_first': '請先選擇一個客戶',
  'oms.common.no_relevant_data': '沒有合適的選項',
  'oms.common.ftp-folder': 'FTP資料夾',
  'oms.common.serial-scanned-before': '序號{serial_num}之前已掃描過，請檢查',
  'oms.common.any-scanned-before': '{codenum}已被掃描，請檢查',
  'oms.common.pick_multi_item': '多個',
  'oms.common.pick_simple_item': '1個',
  'oms.common.confirm-yes': '是的，確認',
  'oms.common.receiving_uuid': '收貨ID',
  'oms.common.serial-scanned-max-qty': '只需掃描 {length} 個序列號',
  'oms.common.require_scan_serial_number_length': '需要掃描 {length} 個序列號',
  'oms.common.sorting_expiry_date_tooltips': '貨品已過期, 真的確認要收貨嗎?',
  'oms.common.warning.duplicate-serial-number': '序號 {serialNum} 已在oms中存在,請檢查',
  'oms.common.warning.sku-require-scan-serial-number': `產品號碼 SKU - {scannedEanOrUpcCode} 包裝時須要掃描序列號`,
  'oms.common.warning.serial-number-already-scanned': '序號 {ssn} 之前已經掃描過',
  'oms.common.column-search-value-placeholder': '搜尋值',
  'oms.common.printing': '列印中 ...',

};
